module.exports = __webpack_public_path__ + "img/Balkon09.21489f95.webp";